module.exports = __webpack_public_path__ + "static/media/gatehouse.7944433a.png";